import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptionsArgs } from '@angular/http';
import { CompleterData, CompleterItem } from "ng2-completer";
import { Subject } from 'rxjs/Subject';
import { environment } from "environments/environment";
import { PlatformLocation } from '@angular/common';
import { AccountService } from 'app/account/account.service';

@Injectable()
export class CustomData extends Subject<CompleterItem[]> implements CompleterData {
  
  public serviceStackUrl;
  private sessionId = 'Empty'; 
  
  constructor(
      private http: Http, 
      private _accountService: AccountService,
      platformLocation: PlatformLocation
    ) {
      super();
      this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
      this._accountService.authToken.subscribe((token) => {
        this.sessionId = token;
      });
  }

  public search(term: string): void {
      this.http.get(this.serviceStackUrl + "Asset-GetScriptureReference?reference=" + term + ",contains", this.buildOptions())      
      .map((res: Response) => {
            // Convert the result to CompleterItem[]
            let data = res.json();
            if (data.Success) {
                localStorage.setItem('scriptureResults',JSON.stringify(data.References));
                let matches: CompleterItem[] = data.References.map((Name: any) => this.convertToItem(Name));
                this.next(matches);
            }
        })
        .subscribe();
  }

  public cancel() {
      // Handle cancel
  }

  public convertToItem(data: any): CompleterItem | null {
      if (!data) {
          return null;
      }
      // data will be string if an initial value is set
      return {
          title: typeof data === "string" ? data : data.Name
      } as CompleterItem;
  }

  private buildOptions() : RequestOptionsArgs {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer ' + this.sessionId);
    return { headers: headers };
  }

}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/media-search/custom.service.ts